var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetDividendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 4,
    fill: "#ECEFFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2377_19083",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 20,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2377_19083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 20.5C18.2778 20.5 18.5139 20.4028 18.7083 20.2083C18.9028 20.0139 19 19.7778 19 19.5C19 19.2222 18.9028 18.9861 18.7083 18.7917C18.5139 18.5972 18.2778 18.5 18 18.5C17.7222 18.5 17.4861 18.5972 17.2917 18.7917C17.0972 18.9861 17 19.2222 17 19.5C17 19.7778 17.0972 20.0139 17.2917 20.2083C17.4861 20.4028 17.7222 20.5 18 20.5ZM14.0625 20.5L19 15.5625L17.9375 14.5L13 19.4375L14.0625 20.5ZM14 16.5C14.2778 16.5 14.5139 16.4028 14.7083 16.2083C14.9028 16.0139 15 15.7778 15 15.5C15 15.2222 14.9028 14.9861 14.7083 14.7917C14.5139 14.5972 14.2778 14.5 14 14.5C13.7222 14.5 13.4861 14.5972 13.2917 14.7917C13.0972 14.9861 13 15.2222 13 15.5C13 15.7778 13.0972 16.0139 13.2917 16.2083C13.4861 16.4028 13.7222 16.5 14 16.5ZM16 24C14.1944 24 12.6597 23.3681 11.3958 22.1042C10.1319 20.8403 9.5 19.3056 9.5 17.5C9.5 16.1528 10.0174 14.7292 11.0521 13.2292C12.0868 11.7292 13.7361 9.98611 16 8C18.3056 10.0833 19.9653 11.8681 20.9792 13.3542C21.9931 14.8403 22.5 16.2257 22.5 17.5104C22.5 19.309 21.8681 20.8403 20.6042 22.1042C19.3403 23.3681 17.8056 24 16 24ZM16 22.5C17.3889 22.5 18.5694 22.0139 19.5417 21.0417C20.5139 20.0694 21 18.8898 21 17.5027C21 16.5565 20.625 15.5208 19.875 14.3958C19.125 13.2708 17.8333 11.7986 16 9.97917C14.1667 11.7986 12.875 13.2708 12.125 14.3958C11.375 15.5208 11 16.5565 11 17.5027C11 18.8898 11.4861 20.0694 12.4583 21.0417C13.4306 22.0139 14.6111 22.5 16 22.5Z",
    fill: "#3F25AE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetDividendIcon);
export default __webpack_public_path__ + "static/media/net-dividend-icon.d3903519144d213f54cee2ac32160484.svg";
export { ForwardRef as ReactComponent };